"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TokenProvider = {
    getAccessToken: null,
};
exports.setAccessTokenProviderFunction = function (getAccessTokenFunction) {
    TokenProvider.getAccessToken = getAccessTokenFunction;
};
exports.default = TokenProvider;
//# sourceMappingURL=tokenProvider.js.map